class Blog {
  constructor() {
    this.addEventListeners();
  }

  addEventListeners() {
    let selects = document.querySelectorAll(".refresh-blog-post");

    if (_.isNull(selects) === false) {
      Array.prototype.forEach.call(selects, el => {
        el.addEventListener("change", () => {
          el.parentElement.parentElement.submit();
        });
      });
    }
  }
}

module.exports = Blog;
